const doc = [({"da":({"js":({"admin":({"sheet_layouts_boxes":({"form":({"edit_box_icon":({"the_box_was_saved":"Boksen blev gemt."})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;